<template>
  <b-row>

    <h2 class="pl-1">{{ $t('side_bar.supplier') }}</h2>

    <!--  BEFORE TABLE  -->
    <div class="d-flex justify-content-between col-12">
      <b-col
        md="4"
        class="my-1 px-0"
      >
        <b-form-group
          class="mb-0"
        >
          <b-input-group size="md">
            <b-form-input
              id="filterInput"
              v-model="filter"
              type="search"
              :placeholder="$t('reusable.search_placeholder')"
            />
            <b-input-group-append>
              <b-button
                :disabled="!filter"
                @click="filter = ''"
              >
                {{ $t('reusable.clear_btn') }}
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>

      <div
        class="my-1 float-right"
      >
        <modal-button
          ripple="rgba(113, 102, 240, 0.15)"
          size="xl"
          name="modal-main"
          :modalButton="$t('reusable.modal_add_btn')"
          @btn-emit="createNewSupplier"
          @open-emit="clearData"
          :modal-title="$t('shops_table.add_supplier')"
          variant="success"
        >
          <template v-slot:button @click="createNewSupplier">{{ $t('reusable.modal_add_btn') }}</template>

          <template v-slot:modal-body>
            <div class="d-flex flex-wrap">

              <infinity-scroll-select
                class="col-6 mb-2"
                v-model="countryId"
                apiUrl="regions.fetchCountry"
                :label="$t('shops_table.choose_country')"
              />

              <!--   short_name   -->
              <b-col cols="6">
                <b-form-group
                  :label="$t('shops_table.supplier_short_name')"
                  label-for="defaultLabel"
                >
                  <b-form-input
                    v-model="short_name"
                    id="defaultLabel"
                    size="lg"
                    :placeholder="$t('shops_table.supplier_short_name')"
                  />
                </b-form-group>
              </b-col>

              <!--   full_name   -->
              <b-col cols="6">
                <b-form-group
                  :label="$t('shops_table.supplier_fio')"
                  label-for="defaultLabel"
                >
                  <b-form-input
                    v-model="full_name"
                    id="defaultLabel"
                    size="lg"
                    :placeholder="$t('shops_table.supplier_fio')"
                  />
                </b-form-group>
              </b-col>

            </div>
          </template>
        </modal-button>

      </div>
    </div>

    <!--  TABLE  -->
    <b-col cols="12">
      <b-table
        striped
        hover
        responsive
        sort-icon-left
        :busy="isBusy"
        :items="items"
        :fields="fields"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        :filter="filter"
        :filter-included-fields="filterOn"

        @filtered="onFiltered"
      >
        <template v-slot:head(is_deleted)="data">
          <b-form-select
            size="md"
            v-model="status"
            class="w-100"
          >
            <template #first>
              <option
                selected
                :value="null"
              >
                Выберите статус
              </option>
            </template>
            <option
              v-for="(status, index) in statuses"
              :key="index"
              :value="status"
            >
              {{ status }}
            </option>
          </b-form-select>
        </template>

        <template #cell(is_active)="data">
          <b-form-checkbox
            class="custom-control-success"
            name="check-button"
            v-model="data.item.is_active"
            @change="updateActive(data.item.id,$event)"
            switch
          >
            <span class="switch-icon-left">
              <feather-icon icon="CheckIcon"/>
            </span>
            <span class="switch-icon-right">
              <feather-icon icon="XIcon"/>
            </span>
          </b-form-checkbox>
        </template>

        <template #cell(country.name)="data">
          {{ checkLocales(data.item.country.name) }}
        </template>

        <template #table-busy>
          <div class="text-center text-primary my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong class="ml-1">{{ $t('reusable.isBusy') }}</strong>
          </div>
        </template>

        <template #cell(crud_row)="data">
          <div class="d-flex float-right">

            <b-dropdown
              no-caret
              id="table-action-dropdown"
              variant="link"
              size="md"
            >
              <template
                #button-content
                class="p-0"
              >
                <feather-icon
                  icon="MoreVerticalIcon"
                  class="p-0"
                />
              </template>

              <!--   PREVIEW BUTTON   -->
              <b-dropdown-item
                class="px-0"
              >
                <modal-button
                  ripple="rgba(113, 102, 240, 0.15)"
                  size="xl"
                  :name="`modal-preview-${data.item.id}`"
                  :backdrop-close="true"
                  :hide-footer="true"
                  :modalButton="$t('region_table.country_edit_modal_title')"
                  :id="data.item.id"
                  :modal-title="$t('reusable.preview_btn')"
                  :disableButton="!editAllow"
                  variant="flat-primary"
                  @open-emit="getSupplierById(data.item.id)"
                  @btn-emit="updateSupplier(data.item.id, data.item)"
                >
                  <template
                    v-slot:button
                    style="width: 100% !important;"
                  >
                    <div class="d-flex align-items-center">
                      <feather-icon
                        icon="EyeIcon"
                        size="21"
                        style="margin-right: 6px"
                      />
                      <span>{{ $t('reusable.preview_btn') }}</span>
                    </div>
                  </template>

                  <template v-slot:modal-body>
                    <div class="d-flex flex-wrap">

                      <infinity-scroll-select
                        class="col-6 mb-2"
                        v-model="countryId"
                        :disabled="!editAllow"
                        apiUrl="regions.fetchCountry"
                        :label="$t('shops_table.choose_country')"
                      />

                      <!--   short_name   -->
                      <b-col cols="6">
                        <b-form-group
                          :label="$t('shops_table.supplier_short_name')"
                          label-for="defaultLabel"
                        >
                          <b-form-input
                            v-model="short_name"
                            id="defaultLabel"
                            size="lg"
                            :disabled="!editAllow"
                            :placeholder="$t('shops_table.supplier_short_name')"
                          />
                        </b-form-group>
                      </b-col>

                      <!--   full_name   -->
                      <b-col cols="4">
                        <b-form-group
                          :label="$t('shops_table.supplier_fio')"
                          label-for="defaultLabel"
                        >
                          <b-form-input
                            v-model="full_name"
                            id="defaultLabel"
                            :disabled="!editAllow"
                            size="lg"
                            :placeholder="$t('shops_table.supplier_fio')"
                          />
                        </b-form-group>
                      </b-col>

                      <b-col cols="4">
                        <b-form-group
                          :label="$t('region_table.created_at')"
                          label-for="defaultLabel"
                        >
                          <b-form-input
                            v-model="createdAt"
                            id="defaultLabel"
                            size="lg"
                            :disabled="!editAllow"
                            :placeholder="$t('region_table.created_at')"
                          />
                        </b-form-group>
                      </b-col>

                      <b-col cols="4">
                        <b-form-group
                          :label="$t('region_table.updated_at')"
                          label-for="defaultLabel"
                        >
                          <b-form-input
                            v-model="updatedAt"
                            id="defaultLabel"
                            size="lg"
                            :disabled="!editAllow"
                            :placeholder="$t('region_table.updated_at')"
                          />
                        </b-form-group>
                      </b-col>

                    </div>

                  </template>


                </modal-button>
              </b-dropdown-item>

              <!--  EDIT BUTTON  -->
              <b-dropdown-item
                class="px-0"
              >
                <modal-button
                  ripple="rgba(113, 102, 240, 0.15)"
                  size="xl"
                  :name="`modal-edit-${data.item.id}`"
                  :modalButton="$t('reusable.save_btn')"
                  :id="data.item.id"
                  :modal-title="$t('reusable.modal_edit_btn')"
                  variant="flat-warning"
                  @open-emit="getSupplierById(data.item.id)"
                  @btn-emit="updateSupplier(data.item.id, data.item)"
                >
                  <template
                    v-slot:button
                    style="width: 100% !important;"
                  >
                    <div class="d-flex align-items-center">
                      <feather-icon
                        icon="Edit2Icon"
                        size="21"
                        style="margin-right: 6px"
                      />
                      <span>{{ $t('reusable.modal_edit_btn') }}</span>
                    </div>
                  </template>

                  <template v-slot:modal-body>
                    <div class="d-flex flex-wrap">

                      <infinity-scroll-select
                        class="col-6 mb-2"
                        v-model="countryId"
                        apiUrl="regions.fetchCountry"
                        :label="$t('shops_table.choose_country')"
                      />

                      <!--   short_name   -->
                      <b-col cols="6">
                        <b-form-group
                          :label="$t('shops_table.supplier_short_name')"
                          label-for="defaultLabel"
                        >
                          <b-form-input
                            v-model="short_name"
                            id="defaultLabel"
                            size="lg"
                            :placeholder="$t('shops_table.supplier_short_name')"
                          />
                        </b-form-group>
                      </b-col>

                      <!--   full_name   -->
                      <b-col cols="6">
                        <b-form-group
                          :label="$t('shops_table.supplier_fio')"
                          label-for="defaultLabel"
                        >
                          <b-form-input
                            v-model="full_name"
                            id="defaultLabel"
                            size="lg"
                            :placeholder="$t('shops_table.supplier_fio')"
                          />
                        </b-form-group>
                      </b-col>

                    </div>
                  </template>

                </modal-button>
              </b-dropdown-item>

              <!--  DELETE BUTTON  -->
              <b-dropdown-item>
                <modal-button
                  ripple="rgba(113, 102, 240, 0.15)"
                  size="sm"
                  :name="`modal-delete-${data.item.id}`"
                  :modalButton="$t('region_table.country_delete_modal_title')"
                  :modal-title="$t('region_table.country_delete_modal_title')"
                  variant="flat-danger"
                  :id="data.item.id"
                  @btn-emit="deleteSupplier"
                >
                  <template v-slot:button class="w-100">
                    <div class="d-flex align-items-center">
                      <feather-icon
                        icon="Trash2Icon"
                        size="21"
                        style="margin-right: 6px"
                      />
                      <span>{{ $t('reusable.modal_delete_btn') }}</span>
                    </div>
                  </template>

                  <template v-slot:modal-body>
                    <div class="my-2">
                      {{ $t('shops_table.delete_supplier') }}
                    </div>
                  </template>

                </modal-button>
              </b-dropdown-item>

            </b-dropdown>

          </div>
        </template>
      </b-table>
    </b-col>

    <!--  PAGINATION  -->
    <b-col
      cols="12"
    >
      <b-pagination
        v-if="showPagination"
        v-model="pagination.current"
        :total-rows="pagination.total"
        :per-page="pagination.per_page"
        align="center"
        size="sm"
        class="my-0"
      />
    </b-col>
  </b-row>
</template>

<script>
import {
  BTable,
  BBadge,
  BRow,
  BCol,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BDropdown,
  BDropdownItem,
  BFormCheckbox,
  BSpinner
} from 'bootstrap-vue'
import ModalButton from '@/views/ui/modals/ModalButton.vue'
import api from '@/services/api'
import InfinityScrollSelect from '@/views/ui/infinity-scroll/InfinityScrollSelect'

export default {
  components: {
    BTable,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BDropdown,
    BDropdownItem,
    BFormCheckbox,
    BSpinner,
    ModalButton,
    InfinityScrollSelect
  },
  data() {
    // const query = Object.assign({}, this.$route.query)

    return {
      createdAt: '',
      updatedAt: '',
      editAllow: false,
      isActive: false,
      countryId: null,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      status: null,
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      statuses: [true, false],
      fields: [
        {
          key: 'id',
          label: 'ID',
        },
        {
          key: 'short_name',
          label: this.$t('shops_table.supplier_short_name'),
          sortable: true,
        },
        {
          key: 'full_name',
          label: this.$t('shops_table.supplier_fio'),
          sortable: true,
        },
        {
          key: 'country.name',
          label: this.$t('region_table.country_name'),
          sortable: true,
        },
        {
          key: 'creator.full_name',
          label: this.$t('shops_table.creator_fullName'),
          sortable: true,
        },
        {
          key: 'is_active',
          label: this.$t('shops_table.is_active'),
          sortable: true,
        },
        {
          key: 'created_at',
          label: this.$t('region_table.created_at'),
          sortable: true,
        },
        {
          key: 'updated_at',
          label: this.$t('region_table.updated_at'),
          sortable: true,
        },
        {
          key: 'crud_row',
          label: ' ',
        },
      ],
      variant: '',
      items: [],
      countryName: {
        ru: '',
        uz: ''
      },
      short_name: '',
      full_name: '',
      isBusy: false,
      pagination: {
        current: 1,
        total: 1,
        per_page: 5
      }
    }
  },
  watch: {
    '$route.query': {
      handler(query) {
        this.pagination.current = query.page
        this.fetchSupplierList()
      },
      deep: true,
      immediate: true
    },
    'pagination.current': {
      handler(page) {
        this.replaceRouter({
          ...this.query,
          page,
        })
      },
    }
  },

  computed: {
    rows() {
      return this.items.length
    },

    query() {
      return Object.assign({}, this.$route.query)
    },

    hasItems() {
      return this.items.length > 0
    },

    showPagination() {
      return this.hasItems && !this.isBusy
    },

    sortOptions() {
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({
          text: f.label,
          value: f.key,
        }))
    },
  },

  methods: {

    updateActive(id, active) {
      api.shops.updateSupplierActive(id, active ? 1 : 0)
        .then(res => {
          console.log(res)
        })
        .catch((error) => {
          console.error(error)
        })
        .finally(() => {

        })
    },

    replaceRouter(query) {
      this.$router.replace({ query })
        .catch(() => {
        })
    },

    async fetchSupplierList() {
      const data = {
        with: {
          0: 'creator',
          1: 'country',
        },
        page: this.$route.query.page
      }
      this.isBusy = true
      await api.shops.fetchSupplier(data)
        .then(res => {
          this.isActive = res.data.data.is_active
          this.countryName = res.data.data.country
          this.items = res.data.data
          this.pagination.per_page = res.data.meta.per_page
          this.pagination.total = res.data.meta.total
          this.pagination.current = res.data.meta.current_page
        })
        .catch((error) => {
          console.error(error)
        })
        .finally(() => {
          this.isBusy = false
        })
    },

    async getSupplierById(id) {
      const data = {
        with: {
          0: 'creator',
          1: 'country',
        }
      }
      this.editAllow = false
      await api.shops.fetchOneSupplier(id, data)
        .then(res => {
          this.createdAt = res.data.created_at
          this.updatedAt = res.data.updated_at
          this.short_name = res.data.short_name
          this.full_name = res.data.full_name
          this.countryId = res.data.country
        })
        .catch((error) => {
          console.error(error)
        })
        .finally(() => {

        })
    },

    createNewSupplier() {
      const data = {
        country_id: this.countryId.id,
        short_name: this.short_name,
        full_name: this.full_name,
      }
      api.shops.createSupplier(data)
        .then(res => {
        })
        .catch((error) => {
          console.error(error)
        })
        .finally(() => {
          this.fetchSupplierList()
        })
    },

    clearData() {
      this.short_name = ''
      this.full_name = ''
      this.countryId = []
    },

    deleteSupplier(id) {
      api.shops.deleteSupplier(id)
        .then(res => {
        })
        .catch((error) => {
          console.error(error)
        })
        .finally(() => {
          this.fetchSupplierList()
        })
    },

    updateSupplier(id, data) {
      const body = {
        country_id: this.countryId.id,
        short_name: this.short_name,
        full_name: this.full_name,
      }
      api.shops.updateSupplier(id, body)
        .then(res => {
        })
        .catch((error) => {
          console.error(error)
        })
        .finally(() => {
          this.fetchSupplierList()
        })
    },

    changeVariant(value) {
      if (value.is_active) return 'success'
      return 'danger'
    },

    checkLocales(value) {
      if (localStorage.lang === 'ru') {
        return value.ru
      }
      return value.uz
    },

    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`
      this.infoModal.content = JSON.stringify(item, null, 2)
      this.$root.$emit('bv::show::modal', this.infoModal.id, button)
    },

    resetInfoModal() {
      this.infoModal.title = ''
      this.infoModal.content = ''
    },

    onFiltered(filteredItems) {
      // Trigger pagination to update the number of modals/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
  },
}
</script>

<style lang="scss">

[dir] .dropdown-item {
  padding: 0;
}

</style>
